module.exports = __webpack_public_path__ + "static/img/nologin.5036aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nologin.png
// module id = Uii/
// module chunks = 1